<template>
	<div class="container px-0">
		<b-row class="mt-4 mx-2">
			<b-col cols="12">
				<h2>
					{{ translate('event_flight_information') }}
				</h2>
			</b-col>
			<b-col cols="12">
				<p>
					{{ translate('event_flight_information_description') }}
				</p>
			</b-col>
			<b-col cols="12">
				<event-flight-info
					v-if="!loading && hasStepInfo"
					v-model="value"
					:loading="loading"
					:errors="errorsImport"
					:step-info="stepInfo"
					:flight-info-form="stepInfo.filled_info"
					:flow-name="flowName"
					:disclaimer="disclaimer"
					@disclaimer-change="$emit('disclaimer-change', $event)" />
			</b-col>
		</b-row>
	</div>
</template>
<script>
import {
	Popups, PersonalInformation, Onboarding, Events,
} from '@/translations';
import EventFlightInfo from '@/views/EventOnboarding/components/EventFlightInfo';

export default {
	components: { EventFlightInfo },
	messages: [Popups, PersonalInformation, Onboarding, Events],
	props: {
		value: {
			type: Object,
			default: () => ({}),
		},
		loading: {
			type: Boolean,
			default: false,
		},
		stepInfo: {
			type: Object,
			default: () => ({}),
		},
		errorsImport: {
			type: Object,
			default: () => ({}),
		},
		disclaimer: Boolean,
	},
	data() {
		return {
			alert: new this.$Alert(),
		};
	},
	computed: {
		hasStepInfo() {
			return this.stepInfo && Object.keys(this.stepInfo).length > 0;
		},
		flowName() {
			return this.$route.params.flowName;
		},
	},
};
</script>
